import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { toast } from "sonner";
import { sirenEnabled, setSirenEnabled, unlockAudio, playSiren } from "@/lib/siren";

export default function SirenToggle() {
  const [on, setOn] = useState(sirenEnabled());
  const toggle = () => {
    const next = !on;
    setSirenEnabled(next); setOn(next);
    if (next) { unlockAudio(); playSiren(1.2); toast.success("Siren on — plays for new boots, runner tags and overdue alerts"); }
    else toast("Siren off");
  };
  return (
    <button type="button" onClick={toggle}
      className="w-full px-3 py-2 text-sm flex items-center justify-between gap-2 hover:bg-[#1C263B] rounded-sm"
      data-testid="siren-toggle" data-state={on ? "on" : "off"}>
      <span className="flex items-center gap-2">
        {on ? <Volume2 className="w-4 h-4 text-red-400" /> : <VolumeX className="w-4 h-4 text-[#94A3B8]" />}
        Siren alert sound
      </span>
      <span className={`text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-full border ${on ? "border-red-500/40 text-red-300 bg-red-500/10" : "border-[#28364F] text-[#94A3B8]"}`}>{on ? "On" : "Off"}</span>
    </button>
  );
}
